import { ControlType, FieldBase, FieldBaseOptions } from './field-base';

const DEFAULT_NUM_FILES = 5;

export type FileType = 'image';

export interface FileUploadGroupFieldOptions extends FieldBaseOptions {
  fileType: FileType;
  uploadUrl: string;
  numFiles: number;
}

export class FileUploadGroupField extends FieldBase<string[]> {
  readonly controlType: ControlType = 'file';
  fileType: FileType;
  uploadUrl: string;
  numFiles: number;

  constructor(options: FileUploadGroupFieldOptions) {
    super(options);
    if (!options.uploadUrl) {
      throw new Error('uploadUrl is required.');
    }
    this.fileType = options.fileType || 'image';
    this.numFiles = options.numFiles || DEFAULT_NUM_FILES;
    this.uploadUrl = options.uploadUrl;
    this.value = [];
  }
}
